import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ChartFunnelIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-chart-funnel${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M2.92466 2H13.0753C13.1809 2.00008 13.285 2.02523 13.3789 2.07339C13.4729 2.12155 13.554 2.19133 13.6158 2.277C13.6775 2.36267 13.7179 2.46176 13.7339 2.56613C13.7498 2.6705 13.7407 2.77716 13.7073 2.87733L10.304 13.088C10.2155 13.3536 10.0457 13.5846 9.8186 13.7483C9.59149 13.912 9.31862 14.0001 9.03866 14H6.96133C6.68138 14.0001 6.40851 13.912 6.1814 13.7483C5.95429 13.5846 5.78446 13.3536 5.696 13.088L2.29333 2.87733C2.25999 2.77722 2.25088 2.67062 2.26677 2.5663C2.28266 2.46198 2.32308 2.36292 2.38471 2.27727C2.44635 2.19162 2.52743 2.12182 2.6213 2.07362C2.71517 2.02542 2.81914 2.00019 2.92466 2Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 6H12.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 10H11.3333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ChartFunnelIcon;
